import React from "react";
import SVG from "react-inlinesvg";
import { Col, Modal, Nav, Row, Tab } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import {
    errorMessage,
    formatAmount,
    formatDate,
    formatStatus,
} from "../../../../util/Helpers";
import DynamicSimpleTable from "../../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";

const ViewCardModal = ({ showViewCardModal, details, onHide }) => {
    return (
        <Modal
            show={showViewCardModal}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                        />
                    </span>
                    {details?.cardName}
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2 pb-12"
            >
                <Tab.Container id="left-tabs-example" defaultActiveKey={""}>
                    <Row style={{ height: "calc(100vh - 220px)" }}>
                        <Col
                            sm={3}
                            className={"d-flex flex-column pl-0 border-right h-100"}
                        >
                            <div className={"flex-fill overflow-auto"}>
                                <Nav variant="pills">
                                    <Nav.Item className={"w-100"}>
                                        <Nav.Link eventKey={""}>
                                            <div>Details</div>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className={"w-100"}>
                                        <Nav.Link eventKey={"transactions"}>
                                            <div>Transactions</div>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                        </Col>
                        <Col sm={9} className={"overflow-auto h-100"}>
                            <Tab.Content className={"h-100"}>
                                <Tab.Pane eventKey={""} className={"h-100"}>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6>Card ID</h6>
                                            <span className="text-muted">{details?.id}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Provider Card ID</h6>
                                            <span className="text-muted">{details?.providerCardId}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6>Provider User ID</h6>
                                            <span className="text-muted">{details?.providerUserId}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Tracking Number</h6>
                                            <span className="text-muted">{details?.trackingNumber}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6 className=" px">Card Name</h6>
                                            <span className="text-muted">{details?.cardName}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Card Type</h6>
                                            <span className="text-muted">{details?.cardType}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Status</h6>
                                            <span className="text-muted">{details?.status}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6>Last 4</h6>
                                            <span className="text-muted">{details?.last4}</span>
                                        </div>
                                        <div className="col-lg-4 py-4">
                                            <h6>Currency</h6>
                                            <span className="text-muted">{details?.currency}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Balance</h6>
                                            <span className="text-muted">{formatAmount(details?.currency, details?.balance)}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg py-4">
                                            <h6>Expiry Date</h6>
                                            <span className="text-muted">{details?.expiry}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Valid Date</h6>
                                            <span className="text-muted">{details?.validDate}</span>
                                        </div>
                                        <div className="col-lg py-4">
                                            <h6>Single Use</h6>
                                            <span className="text-muted">{details?.singleUse ? "True" : "False"}</span>
                                        </div>
                                    </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey={"transactions"} className={"h-100"}>
                                    <DynamicSimpleTable
                                        source={{ url: `/cards/transactions` }}
                                        queryParams={
                                            `userGroup=${details?.userGroup}`
                                            + `&userId=${details?.userId}`
                                            + `&cardId=${details?.id}`
                                        }
                                        columns={[
                                            { title: "ID", key: "id" },
                                            { title: "TYPE", key: "type" },
                                            { title: "CURRENCY", key: "currency" },
                                            { title: "AMOUNT", key: "amount" },
                                            { title: "BEFORE", key: "cardBalanceBefore" },
                                            { title: "AFTER", key: "cardBalanceAfter" },
                                            { title: "NARRATIVE", format: row => <div style={{width: "300px"}}>{row.narrative}</div>},
                                            { title: "CREATED AT", format: row => formatDate(row.created) },
                                            { title: "STATUS", format: row => formatStatus(row.status) },
                                        ]}
                                        onError={err => cogoToast.error(errorMessage(err))}
                                        refreshIcon={false}
                                        searchBox={false}
                                    />
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Modal.Body>
        </Modal>

    );
}

export default ViewCardModal;